import {
  AlertDialog, AlertDialogTrigger, AlertDialogContent, AlertDialogHeader,
  AlertDialogTitle, AlertDialogDescription, AlertDialogFooter, AlertDialogAction, AlertDialogCancel,
} from "@/components/ui/alert-dialog";

export function ConfirmButton({
  onConfirm,
  children,
  testId,
  title = "Save changes?",
  description = "Are you sure you want to save these changes?",
  confirmLabel = "Yes, save",
  className = "",
  style = {},
  disabled = false,
}) {
  return (
    <AlertDialog>
      <AlertDialogTrigger asChild>
        <button type="button" data-testid={testId} disabled={disabled} className={className} style={style}>{children}</button>
      </AlertDialogTrigger>
      <AlertDialogContent className="surface" style={{ background: "var(--page-card)", color: "var(--page-text)" }}>
        <AlertDialogHeader>
          <AlertDialogTitle className="font-display text-2xl">{title}</AlertDialogTitle>
          <AlertDialogDescription className="text-muted-page">{description}</AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel data-testid={`${testId}-cancel`}>Cancel</AlertDialogCancel>
          <AlertDialogAction data-testid={`${testId}-confirm`} onClick={onConfirm} style={{ background: "var(--brand)", color: "#fff" }}>{confirmLabel}</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
